<div *ngIf="customFields?.length" class="gridCellContainer">
    <small *ngFor="let customField of customFields">
        <strong>{{ customField.name }}:&nbsp;</strong>{{ customField.value }}
    </small>
</div>
